import { PageTemplate } from "../../templates/PageTemplate";
import { PolicySectionList } from "../../legal/PolicySectionList";
import { PrivacyControlsPanel } from "../../legal/PrivacyControlsPanel";
import { privacySections } from "../../../content/legal";
import { LEGAL_CONTACTS, PRODUCT_NAME } from "../../../lib/legal/config";

export function PrivacyPage() {
  return (
    <PageTemplate
      id="privacy-page"
      header={{
        kicker: "Privacy",
        title: `${PRODUCT_NAME} Privacy Policy`,
        description: `${PRODUCT_NAME} is local-first by default. This policy explains what data the current application stores locally, when data may leave the device, what processors are involved, and how users can control diagnostics and workspace data.`,
      }}
    >
      <PrivacyControlsPanel />

      <section className="mt-8 rounded-[1.75rem] border border-black/10 bg-white/60 p-6">
        <h2 className="text-xl font-bold text-brand-ink tracking-[-0.02em]">Privacy requests</h2>
        <p className="mt-3 text-sm text-brand-muted leading-relaxed max-w-[82ch]">
          Privacy requests and questions should be sent to {LEGAL_CONTACTS.privacyEmail}. This is
          currently a placeholder and must be finalized before public launch.
        </p>
      </section>

      <div className="mt-8">
        <PolicySectionList sections={privacySections} />
      </div>
    </PageTemplate>
  );
}
